import { Button, Card, Col, Row, Space, Typography } from 'antd';
import { GithubOutlined, PlayCircleOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const featuredProjects =  [
  {
    name: "DJ Depot",
    githubUrl: 'https://github.com/diplomatic-immutable/shrimpdomain',
    description: `A one 
      stop shop for both DJs and clients to book gigs, link your mixes, and negotiate rates 
      by creating your own personalized profile.`
  },
  {
    name: "Forever Jen",
    githubUrl: 'https://github.com/diplomatic-immutable/foreverjen',
    description: `A tribute site to my best friend who passed away from cancer`
  },
  {
    name: "MLB Analytics Tools",
    githubUrl: '',
    description: `Coming soon...`
  }
]

const ProjectsSection = () => (
  <section id="projects" className="projects-section">
    <Title level={2}>Featured Projects</Title>
    <Paragraph type='secondary'>These repos may or may not be private. 
      You can contact me to discuss access.
    </Paragraph>
    <Row gutter={[24, 24]}>
      {featuredProjects.map((project) => (
        <Col xs={24} md={12} lg={8} key={project.name}>
          <Card hoverable className="project-card">
            <Title level={4}>{project.name}</Title>
            <Paragraph className='project-card-description'>
              {project.description}
            </Paragraph>
            <Space size="small" className="project-card-actions">
              <Button 
                type="link"
                href={project.githubUrl}
                target="_blank"
                rel="noreferrer"
                icon={<GithubOutlined />}
              >
                Code
              </Button>
            </Space>
          </Card>
        </Col>
      ))}
    </Row>
  </section>
);

export default ProjectsSection;
